import settings from './settings';
import axios from 'axios';

export async function getMeasures(accessToken, deviceId, measures_filter){
  return axios.get(settings.endpoints.getMeasures(deviceId),{
    params: measures_filter,
    headers: {
      Authorization: accessToken
    }
  })
}

export async function getUserDevices(accessToken){
  return axios.get(settings.endpoints.getUserDevices(),{
    headers: {
      Authorization: accessToken
    }
  })
}
